// Generated by ReScript, PLEASE EDIT WITH CARE


function reducer(state, action) {
  switch (action.TAG | 0) {
    case /* SetStep */0 :
        return {
                steps: action._0,
                mapCenter: state.mapCenter,
                address: state.address,
                geoAddress: state.geoAddress
              };
    case /* SetMapCenter */1 :
        return {
                steps: state.steps,
                mapCenter: action._0,
                address: state.address,
                geoAddress: state.geoAddress
              };
    case /* SetAddress */2 :
        return {
                steps: state.steps,
                mapCenter: state.mapCenter,
                address: action._0,
                geoAddress: state.geoAddress
              };
    case /* SetGeoPostalAddress */3 :
        return {
                steps: state.steps,
                mapCenter: state.mapCenter,
                address: state.address,
                geoAddress: action._0
              };
    
  }
}

function getInitialState(param) {
  return {
          steps: /* SelectLocation */0,
          mapCenter: {
            lat: 0.0,
            lng: 0.0
          },
          address: undefined,
          geoAddress: undefined
        };
}

export {
  reducer ,
  getInitialState ,
}
/* No side effect */
